import { render, staticRenderFns } from "./DueDateSelector.vue?vue&type=template&id=52d996d0&scoped=true"
import script from "./DueDateSelector.vue?vue&type=script&lang=js"
export * from "./DueDateSelector.vue?vue&type=script&lang=js"
import style0 from "./DueDateSelector.vue?vue&type=style&index=0&id=52d996d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d996d0",
  null
  
)

export default component.exports